<template>
  <a-card>
    <a-form-model v-if="!hasRelPro" :model="form" ref="form" class="pick-100 form-input">
      <a-row>
<!--        <a-col :span="11">-->
<!--          <a-form-item label="风险等级" >-->
<!--            <a-input v-model="form.name" />-->
<!--          </a-form-item>-->
<!--        </a-col>-->
        <a-col :span="11" >
          <a-form-item label="年度">
            <a-select  v-model="form.year" @popupScroll="onYearChange" @change="handlePanelChange1">
              <a-select-option v-for="(item,index) in yearData" :value="item" :key="index">
                {{item}}年
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24" class="footer-button">
          <a-form-item :wrapperCol="{ span: 23 }" style="text-align: center">
            <a-button type="primary" style="margin-right: 20px" :loading="loading" @click="onSearch">查询
            </a-button>
            <a-button @click="reset">重置</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form-model>
    <s-table
            ref="table"
            :columns="columns"
            :data="loadData"
            :customRow="customRow"
            :rowKey="record => record.id"
            :pagination="{ showTotal: () => `共 ${total} 条` }"
    >
      <template slot="action" slot-scope="record">
        <a-button style="margin: 0px 5px"  size="small" @click.stop="onEdit(record)">修改</a-button>
        <a-button style="margin: 0px 5px"  size="small" @click.stop="onDel(record)">删除</a-button>
      </template>
<!--      <template slot="operation" slot-scope="record">-->
<!--        <a-button-group v-show="!hasRelPro">-->
<!--          <a-button @click="onDetail(record)">查看</a-button>-->
<!--        </a-button-group>-->
<!--        <a-button-group v-show="hasRelPro">-->
<!--          <a-button @click="onSel(record)">选择</a-button>-->
<!--        </a-button-group>-->
<!--      </template>-->
    </s-table>
  </a-card>
</template>

<script>
import UserSelector from '@/components/selector/UserSelector'
import STable from '@/components/Table'
import DeptSelector from '@/components/selector/DeptSelector'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  name: 'ExpertYearAssessSTable',
  components: {
    DeptSelector,
    STable,
    UserSelector
  },
  props: {
    param: {
      type: Object,
      default: () => {
        return {}
      }
    },
    caseTypeId: {
      type: String
    },
    // 是否自己申请
    hasRelPro: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.getYearData()
  },
  data () {
    return {
      columns: [
        {
          title: '评价人',
          dataIndex: 'extras.userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '评价时间',
          dataIndex: 'addTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '被评专家',
          dataIndex: 'extras.expertName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '评价等级',
          dataIndex: 'extras.levelName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '评分',
          dataIndex: 'score',
          ellipsis: true,
          align: 'center'
        }
        // ,
        // { title: '操作', scopedSlots: { customRender: 'action' }, width: '150px' }
      ],
      user: this.$ls.get('user'),
      permissions: this.hasRelPro ? '' : 'D',
      form: {},
      // 当触发操作列 的 按钮时，不触发详情onView
      ifOperation: false,
      isManager: false,
      total: null,
      yearData: [],
      customRow: (record, index) => {
        return {
          on: {
            click: () => {
              this.onXwfView(record)
            }
          }
        }
      },
      loadData: (parameter) => {
        const data = { ...this.param, ...this.form }
        return this.$http.get('/api/1/expertyearassess/query_ExpertYearAssess_list.json', {
          params: Object.assign(parameter, data)
        }).then(res => {
          if (res.page) {
            this.total = res.page.total
          }
          return res
        })
      }
    }
  },
  methods: {
    // 重置
    reset () {
      this.form = {}
      this.ESTrefresh()
    },
    // 搜索
    onSearch (paramObj) {
      // debugger
      // if (paramObj && JSON.stringify(paramObj) != '{}') {
      //   this.form = paramObj
      // }
      this.ESTrefresh()
    },
    // 刷新
    ESTrefresh () {
      this.$refs.table.refresh()
    },
    onView (record) {
      // 当触发操作列 的 按钮时，不触发详情onView
      if (this.ifOperation) {
        return
      }
      var routeIndex = this.$router.resolve({
        path: '/attendance/evection/view/ro',
        query: { id: record.id, time: new Date().getTime() }
      })
      window.xt.winopen(routeIndex.href, '_blank', this.$ls.get(ACCESS_TOKEN), 0.8)
    },
    onXwfView (record) {
      this.$router.push({ path: '/expertYearAssess/view?id=' + record.id })
    },
    onDetail (record) {
      // 当触发操作列 的 按钮时，不触发详情onView
      this.ifOperation = true
      this.$router.push({
        path: `/projectApply/detail?id=${record.projectApplyId}`
      })
    },
    onSel (record) {
      // 当触发操作列 的 按钮时，不触发详情onView
      this.ifOperation = true
      this.$emit('onSel', record)
    },
    onDept (e) {
      this.form.deptId = e
    },
    onChangUser (e) {
      this.form.userIds = e
    },
    onEdit (e) {
      this.$router.push({ path: `/notice/edit?id=${e.id}` })
    },
    onDel (e) {
      this.delLoading = true
      this.$http.post(`/api/1/notice/delete_ImNotice.json?id=${e.id}`).then(res => {
        this.delLoading = false

        if (res.code !== 200) {
          this.$message.error('删除失败')
          return
        }
        this.$message.success('删除成功')
        // this.$router.push({ path: '/attendance/evection/index' })
        this.ESTrefresh()
      })
    },
    getYearData () {
      let dateNow = new Date()
      let month = dateNow.getMonth() + 1
      let year = dateNow.getFullYear()
      let arr = []
      arr.push(year)
      for (let i = 0, j = 1; i < 10; i++, j++) {
        arr.push(year - j)
        // arr.push(year + j)
      }
      // for (let i = 0, j = 1; i < 5; i++, j++) {
      //   arr.push(year + j)
      // }
      arr.sort((val1, val2) => val2 - val1)
      this.yearData = arr
    },
    handlePanelChange1 (value, mode) {
      console.log(value)
      // this.statisYear.time = value
    },
    onYearChange (e) {
      const { target } = e
      if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
        var year = Math.min.apply(null, this.yearData)
        for (let i = 0, j = 1; i < 10; i++, j++) {
          this.yearData.push(year - j)
        }
        this.yearData.sort((val1, val2) => val2 - val1)
      } else if (target.scrollTop === 0) {
        var year1 = Math.max.apply(null, this.yearData)
        for (let i = 0, j = 1; i < 5; i++, j++) {
          this.yearData.push(year1 + j)
        }
        this.yearData.sort((val1, val2) => val2 - val1)
      }
    }
  }
}
</script>

<style scoped>
/deep/ .ant-form-item-label{
  flex: 0 0 145px!important;
}
.form-input /deep/ .ant-calendar-picker {
  width: 46% !important;
}
</style>
